import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { AbstractBasicSignalInput } from '../abstract-basic-signal-input.component';
import { FocusDirective } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-ui-textarea',
  imports: [FormsModule, NgClass, NgTemplateOutlet, FocusDirective],
  templateUrl: './textarea.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextareaComponent extends AbstractBasicSignalInput<string> {
  readonly rows = input(2);
}
